(function(){
  'use strict';

  function forceBlackHamburgerToFullMenu(){
    if(window.innerWidth>1024||!window.jQuery)return;
    var $=window.jQuery;
    var $btn=$('header.headertype3 .tt-mobile-header .tt-mobile-parent-menu .tt-menu-toggle').first();
    var $full=$('.mobile-caterorie-menu').first();
    if(!$btn.length||!$full.length||typeof $full.openmm!=='function')return;
    $btn.removeClass('mainmenumob-js').addClass('catmenumob-js');
    $btn.off('click.jsMobileFullMenu').off('click');
    $btn.on('click.jsMobileFullMenu',function(e){
      e.preventDefault();e.stopImmediatePropagation();
      $('.mobile-main-menu.mmitemopen').hide().removeClass('mmitemopen');
      $('body').removeClass('mm-open');
      $full.openmm();
      return false;
    });
  }

  function putNewsletterBeforeFooterMenu(){
    if(window.innerWidth>767)return;
    var footer=document.querySelector('footer.for-footer-blocks');
    if(!footer)return;
    var newsletter=footer.querySelector('.jschar-footer-zone');
    if(!newsletter)return;
    /* Make the newsletter the first direct footer block. This avoids
       relying on .js-footer-modern being a direct child in every footer variant. */
    if(footer.firstElementChild!==newsletter){
      footer.insertBefore(newsletter,footer.firstElementChild);
    }
  }

  function findTrustpilotWrap(){
    var wrap=document.querySelector('.js-trustpilot-review-bottom');
    if(wrap)return wrap;
    var root=document.getElementById('tt-pageContent')||document;
    var nodes=root.querySelectorAll('a,button,[role="button"]');
    for(var i=0;i<nodes.length;i++){
      var el=nodes[i];
      var text=(el.textContent||'').replace(/\s+/g,' ').trim().toLowerCase();
      var href=(el.getAttribute('href')||'').toLowerCase();
      if(((text.indexOf('review us')!==-1&&text.indexOf('trust')!==-1)||
          text.indexOf('trustpilot')!==-1||href.indexOf('trustpilot')!==-1)&&
         !el.closest('.jdgm-review-widget')){
        wrap=document.createElement('div');
        wrap.className='js-trustpilot-review-bottom';
        el.parentNode.insertBefore(wrap,el);
        wrap.appendChild(el);
        return wrap;
      }
    }
    return null;
  }

  function moveTrustpilotBelowTrustBadges(){
    if(!document.body.classList.contains('js-product-page'))return;
    var badgeSection=document.getElementById('shopify-section-171638965910c9b5bd');
    if(!badgeSection)return;
    var wrap=findTrustpilotWrap();
    if(!wrap)return;
    if(wrap.previousElementSibling!==badgeSection){
      badgeSection.parentNode.insertBefore(wrap,badgeSection.nextSibling);
    }
    wrap.style.marginTop='18px';
    wrap.style.marginBottom='18px';
    wrap.style.textAlign='center';
  }

  function apply(){
    forceBlackHamburgerToFullMenu();
    putNewsletterBeforeFooterMenu();
    moveTrustpilotBelowTrustBadges();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply,{once:true});else apply();
  window.addEventListener('load',apply,{once:true});
  document.addEventListener('shopify:section:load',function(){setTimeout(apply,0)});
  [120,450,1000,2200,4200,6500].forEach(function(ms){setTimeout(apply,ms)});
})();
